import { createFileRoute } from '@tanstack/react-router'
import { PromoBannersPage } from '@/features/promo-banners'

export const Route = createFileRoute('/_authenticated/promo-banners/')({
  component: PromoBannersPage,
})
